import { useEffect, useState, useMemo, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import InputTextField from "../InputText/InputText";
import { baseurl } from "../BaseUrl/Baseurl";
import axios from "axios";
import { useSelector } from "react-redux";
import { IoCloseSharp } from "react-icons/io5";
import MultiSelectDropdown from "../AdminConsole/MultiSelect";

const safeAxios = (config) => {
  try {
    const res = axios(config);
    return res && typeof res.then === "function"
      ? res
      : Promise.resolve(res || {});
  } catch (err) {
    return Promise.reject(err);
  }
};

export default function RegionEditModal({
  status,
  btnClick,
  modalname,
  fieldName,
  toEditid,
  fieldValue,
  onSuccess,
  onError,
  field,
  editData,
}) {
  const [circle, setcircle] = useState(fieldValue || "");
  const [circleValid, setcircleValid] = useState(
    Boolean(fieldValue && fieldValue.trim().length > 0),
  );
  const [circleerror, setcircleerror] = useState("");

  const [state, setState] = useState("");
  const [initialState, setInitialState] = useState("");
  const [stateOptions, setStateOptions] = useState([]);

  const [childOptions, setChildOptions] = useState([]);
  const [selectedChildIds, setSelectedChildIds] = useState([]);
  const [initialChildIds, setInitialChildIds] = useState([]);

  const [locationDescription, setLocationDescription] = useState(
    editData?.locationDescription || editData?.location_description || "",
  );
  const [initialLocationDescription, setInitialLocationDescription] = useState(
    editData?.locationDescription || editData?.location_description || "",
  );

  const detailsAppliedRef = useRef(false);
  const userData = useSelector((state) => state.userDetails);

  const childConfig = useMemo(() => {
    switch (field) {
      case "area":
        return {
          childField: null,
          childLabel: null,
          listKey: null,
          payloadKey: null,
          hasState: true,
        };
      case "subDivision":
        return {
          childField: "area",
          childLabel: "Choose Area",
          listKey: "areaList",
          payloadKey: "areaId",
          hasState: false,
        };
      case "division":
        return {
          childField: "subDivision",
          childLabel: "Choose Sub Division",
          listKey: "subDivisionList",
          payloadKey: "subDivisionId",
          hasState: false,
        };
      case "circle":
        return {
          childField: "division",
          childLabel: "Choose Division",
          listKey: "divisionList",
          payloadKey: "divisionId",
          hasState: false,
        };
      case "wing":
        return {
          childField: "circle",
          childLabel: "Choose Circle",
          listKey: "circleList",
          payloadKey: "circleId",
          hasState: false,
        };
      default:
        return null;
    }
  }, [field]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const mapChildListToIds = (rawList, options) => {
    if (!rawList) return [];
    let list = rawList;
    if (typeof list === "string") {
      list = list.split(",").map((s) => s.trim());
    }
    if (!Array.isArray(list)) return [];

    const matched = list
      .map((item) => {
        if (!item && item !== 0) return null;
        if (typeof item === "object" && item !== null) {
          if (item.id !== undefined) return item.id;
        }
        const itemStr =
          typeof item === "object"
            ? String(
                item.name ||
                  item.area ||
                  item.subDivision ||
                  item.division ||
                  item.circle ||
                  "",
              )
            : String(item);
        const found = options.find((opt) => {
          const optName =
            opt.name ||
            opt.area ||
            opt.subDivision ||
            opt.division ||
            opt.circle;
          return (
            (optName &&
              String(optName).trim().toLowerCase() ===
                itemStr.trim().toLowerCase()) ||
            String(opt.id) === itemStr
          );
        });
        if (found) return found.id;
        const num = Number(item);
        return !isNaN(num) ? num : item;
      })
      .filter((id) => id !== null && id !== undefined);

    return Array.from(new Set(matched));
  };

  const resolveAndSetState = (itemState, options) => {
    if (!itemState || !options || options.length === 0) return;
    const foundState = options.find((s) => {
      if (typeof itemState === "object" && itemState !== null) {
        return (
          String(s.id) === String(itemState.id) ||
          (s.name &&
            itemState.name &&
            String(s.name).trim().toLowerCase() ===
              String(itemState.name).trim().toLowerCase())
        );
      }
      return (
        String(s.id) === String(itemState) ||
        (s.name &&
          String(s.name).trim().toLowerCase() ===
            String(itemState).trim().toLowerCase())
      );
    });

    if (foundState) {
      setState(String(foundState.id));
      setInitialState(String(foundState.id));
    } else if (!isNaN(Number(itemState))) {
      setState(String(itemState));
      setInitialState(String(itemState));
    }
  };

  // Load state options if hasState
  useEffect(() => {
    if (!childConfig?.hasState) return;

    safeAxios({
      method: "GET",
      url: `${baseurl}/api/get/list?field=state&userId=${userData.userId}&isSortingRequired=2`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.token}`,
      },
    })
      .then((res) => {
        const list = Array.isArray(res.data?.message) ? res.data.message : [];
        setStateOptions(list);
        const itemState = editData?.state || editData?.stateId;
        if (itemState) {
          resolveAndSetState(itemState, list);
        }
      })
      .catch(console.error);
  }, [childConfig?.hasState, editData?.state, editData?.stateId, userData.userId, userData.token]);

  // Load child options
  useEffect(() => {
    if (!childConfig?.childField) return;

    safeAxios({
      method: "GET",
      url: `${baseurl}/api/get/list?field=${childConfig.childField}&userId=${userData.userId}&isSortingRequired=2`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.token}`,
      },
    })
      .then((res) => {
        const rawOptions = Array.isArray(res.data?.message)
          ? res.data.message
          : [];
        const formatted = rawOptions.map((opt) => {
          const optId =
            opt.id !== undefined
              ? opt.id
              : opt[childConfig.childField + "Id"] !== undefined
                ? opt[childConfig.childField + "Id"]
                : opt[childConfig.childField + "_id"] !== undefined
                  ? opt[childConfig.childField + "_id"]
                  : opt.ID !== undefined
                    ? opt.ID
                    : opt[childConfig.childField];
          return {
            id: optId,
            name: opt.name || opt[childConfig.childField] || optId,
          };
        });
        setChildOptions(formatted);

        const currentList = editData && editData[childConfig.listKey];
        if (currentList) {
          const matchedIds = mapChildListToIds(currentList, formatted);
          setSelectedChildIds(matchedIds);
          setInitialChildIds(matchedIds);
          detailsAppliedRef.current = true;
        }
      })
      .catch(console.error);
  }, [childConfig, editData, userData.userId, userData.token]);

  // If editData details were not initially present, fetch details
  useEffect(() => {
    if (!childConfig || detailsAppliedRef.current) return;

    const hasDirectDetails =
      editData &&
      ((childConfig.listKey && editData[childConfig.listKey] !== undefined) ||
        (childConfig.hasState && editData.state !== undefined));

    if (hasDirectDetails) return;

    safeAxios({
      method: "GET",
      url: `${baseurl}/api/get/list?field=${field}&areDetailsRqd=1&isSortingRequired=1&userId=${userData.userId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.token}`,
      },
    })
      .then((res) => {
        const list = Array.isArray(res.data?.message) ? res.data.message : [];
        const matched = list.find((it) => String(it.id) === String(toEditid));
        if (matched) {
          if (childConfig.hasState && stateOptions.length > 0) {
            resolveAndSetState(matched.state || matched.stateId, stateOptions);
          }
          if (
            childConfig.childField &&
            childOptions.length > 0 &&
            matched[childConfig.listKey]
          ) {
            const matchedIds = mapChildListToIds(
              matched[childConfig.listKey],
              childOptions,
            );
            setSelectedChildIds(matchedIds);
            setInitialChildIds(matchedIds);
            detailsAppliedRef.current = true;
          }
          const matchedLocDesc =
            matched.locationDescription || matched.location_description || "";
          if (matchedLocDesc) {
            setLocationDescription(matchedLocDesc);
            setInitialLocationDescription(matchedLocDesc);
          }
        }
      })
      .catch(console.error);
  }, [childConfig, childOptions, editData, field, stateOptions, toEditid, userData.userId, userData.token]);

  useEffect(() => {
    const locDesc =
      editData?.locationDescription || editData?.location_description || "";
    if (locDesc) {
      setLocationDescription(locDesc);
      setInitialLocationDescription(locDesc);
    }
  }, [editData]);

  const submittingRef = useRef(false);

  function handleTriggerSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (submittingRef.current) return;
    submittingRef.current = true;
    onsubmit(toEditid);
    setTimeout(() => {
      submittingRef.current = false;
    }, 1000);
  }

  function onsubmit(toEditid) {
    setcircleerror("");
    const trimmedName = circle?.trim() || "";
    if (!trimmedName) {
      setcircleerror("Please enter the name ");
      setcircleValid(false);
      submittingRef.current = false;
      return;
    }

    const editedValue = (circle || "").trim().replace(/\s+/g, " ");
    const oldValue = (fieldValue || "").trim().replace(/\s+/g, " ");
    const hasNameChanged = editedValue !== oldValue;

    const hasStateChanged = childConfig?.hasState
      ? String(state || "") !== String(initialState || "")
      : false;

    const currentChildSorted = [...selectedChildIds].map(String).sort();
    const initialChildSorted = [...initialChildIds].map(String).sort();
    const hasChildChanged = childConfig?.childField
      ? JSON.stringify(currentChildSorted) !== JSON.stringify(initialChildSorted)
      : false;

    const trimmedLocDesc = String(locationDescription || "").trim();
    const hasLocDescChanged =
      trimmedLocDesc !== String(initialLocationDescription || "").trim();

    if (!hasNameChanged && !hasStateChanged && !hasChildChanged && !hasLocDescChanged) {
      if (typeof onError === "function") {
        onError("");
        setTimeout(() => {
          onError("No changes made to update");
        }, 10);
      }
      submittingRef.current = false;
      return;
    }

    const formattedStateId = state
      ? !isNaN(Number(state))
        ? Number(state)
        : state
      : undefined;

    const locDescPayload = trimmedLocDesc
      ? { locationDescription: trimmedLocDesc }
      : initialLocationDescription
        ? { locationDescription: "" }
        : {};

    let requestBody = {};
    if (field === "area") {
      requestBody = {
        area: circle,
        id: toEditid,
        ...(formattedStateId ? { stateId: formattedStateId } : {}),
        ...locDescPayload,
      };
    } else if (field === "subDivision") {
      const formattedAreaIds = selectedChildIds.map((id) =>
        !isNaN(Number(id)) ? Number(id) : id,
      );
      requestBody = {
        subDivision: circle,
        id: toEditid,
        areaId: formattedAreaIds,
        ...locDescPayload,
      };
    } else if (field === "division") {
      const formattedIds = selectedChildIds.map((id) =>
        !isNaN(Number(id)) ? Number(id) : id,
      );
      requestBody = {
        division: circle,
        id: toEditid,
        subDivisionId: formattedIds,
        ...locDescPayload,
      };
    } else if (field === "circle") {
      const formattedIds = selectedChildIds.map((id) =>
        !isNaN(Number(id)) ? Number(id) : id,
      );
      requestBody = {
        circle: circle,
        id: toEditid,
        divisionId: formattedIds,
        ...locDescPayload,
      };
    } else if (field === "wing") {
      const formattedIds = selectedChildIds.map((id) =>
        !isNaN(Number(id)) ? Number(id) : id,
      );
      requestBody = {
        wing: circle,
        id: toEditid,
        circleId: formattedIds,
        ...locDescPayload,
      };
    } else {
      requestBody = {
        [field]: circle,
        id: toEditid,
        ...(formattedStateId ? { stateId: formattedStateId } : {}),
        ...locDescPayload,
      };
    }

    safeAxios({
      method: "PUT",
      url: `${baseurl}/api/edit?field=${field}&userId=${userData.userId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userData.token}`,
      },
      data: requestBody,
    })
      .then((response) => {
        submittingRef.current = false;
        onSuccess(response?.data?.message);
        setcircle("");
        setLocationDescription("");
        setcircleerror("");
        btnClick();
      })
      .catch((error) => {
        submittingRef.current = false;
        const errorMsg = error.response?.data?.message;
        if (errorMsg !== undefined) {
          if (typeof onError === "function") {
            onError(errorMsg);
          }
        }
      });
  }

  function handlecircle(e) {
    let val = e.target.value;
    if (val.length > 100) val = val.slice(0, 100);
    setcircle(val);
    setcircleValid(false);
    setcircleerror("");
    validateField(e.target.name, val);
  }

  const validateField = (inputName, value) => {
    if (inputName === "circle") {
      if (value.trim() !== "") {
        setcircleerror("");
        setcircleValid(true);
      } else {
        setcircleerror("Please enter the name ");
        setcircleValid(false);
      }
    }
  };

  return (
    <Modal
      show={status}
      onHide={btnClick}
      className="region-create-modal region-edit-modal"
      centered
    >
      <Modal.Body className="bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0">{modalname}</h6>
          <button className="btn p-0" onClick={btnClick} aria-label="close">
            <IoCloseSharp />
          </button>
        </div>
        <hr className="my-2" />
        <form
          className="row d-flex justify-content-center align-center circlediv"
          autoComplete="off"
          onSubmit={handleTriggerSubmit}
        >
          {childConfig?.hasState && (
            <div className="col-12 col-sm-12 col-lg-6 col-xl-6 col-md-12 pb-2 pt-2">
              <label htmlFor="edit-state" className="login-text">
                Choose State
              </label>
              <center>
                <select
                  id="edit-state"
                  name="state"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  className="project-box"
                >
                  <option value="">Select</option>
                  {stateOptions.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </center>
            </div>
          )}

          <div
            className={`col-12 col-sm-12 ${
              childConfig?.hasState ? "col-lg-6 col-xl-6" : "col-lg-12 col-xl-12"
            } col-md-12 pb-2 pt-2`}
          >
            <label htmlFor="circle" className="login-text">
              {fieldName}
            </label>
            <center>
              <InputTextField
                handleInputChange={handlecircle}
                valueText={circle}
                inputName="circle"
                inputId="circle"
                classname="project-box"
                inputType="text"
                maxLen={100}
                defaultValue={circle}
                autoComplete="off"
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
              />
            </center>
            <div className="login-error pt-1">
              <center>{circleerror}</center>
            </div>
          </div>

          {childConfig?.childField && (
            <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pb-2 pt-2">
              <label className="formfontst ast form-label">
                {childConfig.childLabel}
              </label>
              <MultiSelectDropdown
                options={childOptions}
                onChangefun={setSelectedChildIds}
                value={selectedChildIds}
              />
            </div>
          )}

          <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pb-2 pt-2">
            <label htmlFor="locationDescription" className="login-text">
              Location Description
            </label>
            <center>
              <InputTextField
                handleInputChange={(e) => {
                  const val = e.target.value;
                  setLocationDescription(val.length > 100 ? val.slice(0, 100) : val);
                }}
                valueText={locationDescription}
                inputName="locationDescription"
                inputId="locationDescription"
                classname="project-box"
                inputType="text"
                maxLen={100}
                defaultValue={locationDescription}
                placeholderValue="Enter Location Description"
                autoComplete="off"
                onKeyPress={(e) => {
                  e.key === "Enter" && e.preventDefault();
                }}
              />
            </center>
          </div>

          <div className="col-sm-12 col-lg-12 col-12 col-md-12 col-xl-12 pb-2 pt-2">
            <center>
              <button
                type="submit"
                className="search-circle"
                disabled={!circleValid}
                onMouseDown={handleTriggerSubmit}
                onClick={handleTriggerSubmit}
              >
                <b>Submit</b>
              </button>
            </center>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
